// import saga
import { takeLatest, put, call, all } from "redux-saga/effects";

import {
  GET_TASKS_CRMIT_LIST,
  CREATE_TASK_CRMIT,
  GET_TASK_CRMIT,
  UPDATE_TASK_CRMIT,
  CLAIM_TASK_CRMIT,
  DELETE_TASK_CRMIT,
  GET_TASK_STATUS_LIST_CRMIT,
  SEARCH_TASK_LIST,
  GET_TASK_TYPE_LIST,
  GET_TASK_PRIORITY_LIST,
  GET_SINGLE_TASK_NOTE_DATA,
  CREATE_SINGLE_TASK_NOTE,
  SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER,
  SEARCH_TASK_TIME_ENTRY_LIST,
  CREATE_TASK_TIME_ENTRY,
  ADD_NEW_TASK_STATUS,
  UPDATE_TASK_STATUS,
  DELETE_TASK_STATUS,
  ADD_NEW_TASK_TYPE,
  UPDATE_TASK_TYPE,
  DELETE_TASK_TYPE,
  ADD_NEW_TASK_PRIORITY,
  UPDATE_TASK_PRIORITY,
  DELETE_TASK_PRIORITY,
  GET_TASK_RECENT_ACTIVITY_LIST,
  GET_TASK_CHANGE_LOG_LIST,
  GET_TASK_TEMPLATE_LIST,
  GET_TASK_TEMPLATE_DATA,
  CREATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE,
  DELETE_TASK_TEMPLATE,
  SEARCH_TASK_TEMPLATE_LIST,
  GET_TASK_ATTACHMENT_LIST,
  SEARCH_TASK_ATTACHMENT_LIST,
  GET_TASK_ATTACHMENT_DATA,
  DELETE_TASK_ATTACHMENT,
} from "./actionType";

import {
  getTasksCrmITListSuccess,
  getTasksCrmITListError,
  createTaskCrmITSuccess,
  createTaskCrmITError,
  getTaskCrmITSuccess,
  getTaskCrmITError,
  updateTaskCrmITSuccess,
  updateTaskCrmITError,
  claimTaskCrmITSuccess,
  claimTaskCrmITError,
  deleteTaskCrmITSuccess,
  deleteTaskCrmITError,
  getTaskStatusListCrmITSuccess,
  getTaskStatusListCrmITError,
  searchTaskListSuccess,
  searchTaskListError,
  getTaskTypeListSuccess,
  getTaskTypeListError,
  getTaskPriorityListSuccess,
  getTaskPriorityListError,
  getSingleTaskNoteDataSuccess,
  getSingleTaskNoteDataError,
  createSingleTaskNoteSuccess,
  createSingleTaskNoteError,
  searchSingleJobTaskListForTimerSuccess,
  searchSingleJobTaskListForTimerError,
  searchTaskTimeEntryListSuccess,
  searchTaskTimeEntryListError,
  createTaskTimeEntrySuccess,
  createTaskTimeEntryError,
  addNewTaskStatusSuccess,
  addNewTaskStatusError,
  updateTaskStatusSuccess,
  updateTaskStatusError,
  deleteTaskStatusSuccess,
  deleteTaskStatusError,
  addNewTaskTypeSuccess,
  addNewTaskTypeError,
  updateTaskTypeSuccess,
  updateTaskTypeError,
  deleteTaskTypeSuccess,
  deleteTaskTypeError,
  addNewTaskPrioritySuccess,
  addNewTaskPriorityError,
  updateTaskPrioritySuccess,
  updateTaskPriorityError,
  deleteTaskPrioritySuccess,
  deleteTaskPriorityError,
  getTaskRecentActivityListSuccess,
  getTaskRecentActivityListError,
  getTaskChangeLogListSuccess,
  getTaskChangeLogListError,
  getTaskTemplateListSuccess,
  getTaskTemplateListError,
  getTaskTemplateDataSuccess,
  getTaskTemplateDataError,
  createTaskTemplateSuccess,
  createTaskTemplateError,
  updateTaskTemplateSuccess,
  updateTaskTemplateError,
  deleteTaskTemplateSuccess,
  deleteTaskTemplateError,
  searchTaskTemplateListSuccess,
  searchTaskTemplateListError,
  getTaskAttachmentListSuccess,
  getTaskAttachmentListError,
  searchTaskAttachmentListSuccess,
  searchTaskAttachmentListError,
  getTaskAttachmentDataSuccess,
  getTaskAttachmentDataError,
  deleteTaskAttachmentSuccess,
  deleteTaskAttachmentError,
} from "./action";

import {
  getTasksCrmItListApiCall,
  postTaskCrmItCreateApiCall,
  getTaskCrmItReadApiCall,
  postTaskCrmItUpdateApiCall,
  postTaskCrmItClaimApiCall,
  postTaskCrmItDeleteApiCall,
  getTasksStatusListApiCall,
  postSearchTaskListApiCall,
  getTaskTypeListApiCall,
  getTaskPriorityListApiCall,
  getSingleTaskNoteApiCall,
  postCreateSingleTaskNoteApiCall,
  postSearchSingleJobTaskListForTimerApiCall,
  postSearchTaskTimeEntryListApiCall,
  postCreateTaskTimeEntryApiCall,
  postAddNewTaskStatusApiCall,
  postUpdateTaskStatusApiCall,
  postDeleteTaskStatusApiCall,
  postAddNewTaskTypeApiCall,
  postUpdateTaskTypeApiCall,
  postDeleteTaskTypeApiCall,
  postAddNewTaskPriorityApiCall,
  postUpdateTaskPriorityApiCall,
  postDeleteTaskPriorityApiCall,
  getTaskRecentActivityListApiCall,
  getTaskChangeLogListApiCall,
  //templates
  getTaskTemplateListApiCall,
  getTaskTemplateDataApiCall,
  postCreateTaskTemplateApiCall,
  postUpdateTaskTemplateApiCall,
  postDeleteTaskTemplateApiCall,
  postSearchTaskTemplateListApiCall,
  //attachments
  getTaskAttachmentListApiCall,
  postSearchTaskAttachmentListApiCall,
  getTaskAttachmentDataApiCall,
  postDeleteTaskAttachmentApiCall,
} from "../../helpers/fakebackend_helper";

// get tasksCrmIT list
function* getTasksCrmITList() {
  try {
    const response = yield call(getTasksCrmItListApiCall);
    yield put(getTasksCrmITListSuccess(response));
  } catch (error) {
    yield put(getTasksCrmITListError(error));
  }
}

function* watchGetTasksCrmITList() {
  yield takeLatest(GET_TASKS_CRMIT_LIST, getTasksCrmITList);
}

// create taskCrmIT
function* createTaskCrmIT({ payload }) {
  try {
    const response = yield call(postTaskCrmItCreateApiCall, payload);
    yield put(createTaskCrmITSuccess(response));
  } catch (error) {
    yield put(createTaskCrmITError(error));
  }
}

function* watchCreateTaskCrmIT() {
  yield takeLatest(CREATE_TASK_CRMIT, createTaskCrmIT);
}

// get taskCrmIT
function* getTaskCrmIT({ payload }) {
  try {
    const response = yield call(getTaskCrmItReadApiCall, payload);
    yield put(getTaskCrmITSuccess(response));
  } catch (error) {
    yield put(getTaskCrmITError(error));
  }
}

function* watchGetTaskCrmIT() {
  yield takeLatest(GET_TASK_CRMIT, getTaskCrmIT);
}

// update taskCrmIT
function* updateTaskCrmIT({ payload }) {
  try {
    const response = yield call(postTaskCrmItUpdateApiCall, payload);
    yield put(updateTaskCrmITSuccess(response));
  } catch (error) {
    yield put(updateTaskCrmITError(error));
  }
}

function* watchUpdateTaskCrmIT() {
  yield takeLatest(UPDATE_TASK_CRMIT, updateTaskCrmIT);
}

// claim taskCrmIT (member claims a pooled/team task)
function* claimTaskCrmIT({ payload }) {
  try {
    const response = yield call(postTaskCrmItClaimApiCall, payload);
    yield put(claimTaskCrmITSuccess(response));
  } catch (error) {
    yield put(claimTaskCrmITError(error));
  }
}

function* watchClaimTaskCrmIT() {
  yield takeLatest(CLAIM_TASK_CRMIT, claimTaskCrmIT);
}

// delete taskCrmIT
function* deleteTaskCrmIT({ payload }) {
  try {
    const response = yield call(postTaskCrmItDeleteApiCall, payload);

    yield put(deleteTaskCrmITSuccess(response));
  } catch (error) {
    yield put(deleteTaskCrmITError(error));
  }
}

function* watchDeleteTaskCrmIT() {
  yield takeLatest(DELETE_TASK_CRMIT, deleteTaskCrmIT);
}

// get task status list
function* getTaskStatusListCrmIT() {
  try {
    const response = yield call(getTasksStatusListApiCall);
    yield put(getTaskStatusListCrmITSuccess(response));
  } catch (error) {
    yield put(getTaskStatusListCrmITError(error));
  }
}

function* watchGetTaskStatusListCrmIT() {
  yield takeLatest(GET_TASK_STATUS_LIST_CRMIT, getTaskStatusListCrmIT);
}

// Search Task List APi Data
function* searchTaskList({ payload }) {
  try {
    const response = yield call(postSearchTaskListApiCall, payload);
    yield put(searchTaskListSuccess(response));
  } catch (error) {
    yield put(searchTaskListError(error));
  }
}

function* watchSearchTaskList() {
  yield takeLatest(SEARCH_TASK_LIST, searchTaskList);
}

// Get Task Type List APi Data
function* getTaskTypeList() {
  try {
    const response = yield call(getTaskTypeListApiCall);
    yield put(getTaskTypeListSuccess(response));
  } catch (error) {
    yield put(getTaskTypeListError(error));
  }
}

function* watchGetTaskTypeList() {
  yield takeLatest(GET_TASK_TYPE_LIST, getTaskTypeList);
}

// Get Task Priority List APi Data

function* getTaskPriorityList() {
  try {
    const response = yield call(getTaskPriorityListApiCall);
    yield put(getTaskPriorityListSuccess(response));
  } catch (error) {
    yield put(getTaskPriorityListError(error));
  }
}

function* watchGetTaskPriorityList() {
  yield takeLatest(GET_TASK_PRIORITY_LIST, getTaskPriorityList);
}

// Get Single Task Note Data
function* getSingleTaskNoteData({ payload }) {
  try {
    const response = yield call(getSingleTaskNoteApiCall, payload);
    yield put(getSingleTaskNoteDataSuccess(response));
  } catch (error) {
    yield put(getSingleTaskNoteDataError(error));
  }
}

function* watchGetSingleTaskNoteData() {
  yield takeLatest(GET_SINGLE_TASK_NOTE_DATA, getSingleTaskNoteData);
}

// Create Single Task Note
function* createSingleTaskNoteData({ payload }) {
  try {
    const response = yield call(postCreateSingleTaskNoteApiCall, payload);
    yield put(createSingleTaskNoteSuccess(response));
  } catch (error) {
    yield put(createSingleTaskNoteError(error));
  }
}

function* watchCreateSingleTaskNoteData() {
  yield takeLatest(CREATE_SINGLE_TASK_NOTE, createSingleTaskNoteData);
}

// Search Single Job Tasks List For Timer
function* searchSingleJobTaskListForTimer({ payload }) {
  try {
    const response = yield call(
      postSearchSingleJobTaskListForTimerApiCall,
      payload
    );
    yield put(searchSingleJobTaskListForTimerSuccess(response));
  } catch (error) {
    yield put(searchSingleJobTaskListForTimerError(error));
  }
}

function* watchSearchSingleJobTaskListForTimer() {
  yield takeLatest(
    SEARCH_SINGLE_JOB_TASK_LIST_FOR_TIMER,
    searchSingleJobTaskListForTimer
  );
}

// Search Task Time Entry List
function* searchTaskTimeEntryList({ payload }) {
  try {
    const response = yield call(postSearchTaskTimeEntryListApiCall, payload);
    yield put(searchTaskTimeEntryListSuccess(response));
  } catch (error) {
    yield put(searchTaskTimeEntryListError(error));
  }
}

function* watchSearchTaskTimeEntryList() {
  yield takeLatest(SEARCH_TASK_TIME_ENTRY_LIST, searchTaskTimeEntryList);
}

// Create Task Time Entry
function* createTaskTimeEntry({ payload }) {
  try {
    const response = yield call(postCreateTaskTimeEntryApiCall, payload);
    yield put(createTaskTimeEntrySuccess(response));
  } catch (error) {
    yield put(createTaskTimeEntryError(error));
  }
}

function* watchCreateTaskTimeEntry() {
  yield takeLatest(CREATE_TASK_TIME_ENTRY, createTaskTimeEntry);
}

// Add New Task Status
function* addNewTaskStatus({ payload }) {
  try {
    const response = yield call(postAddNewTaskStatusApiCall, payload);
    yield put(addNewTaskStatusSuccess(response));
  } catch (error) {
    yield put(addNewTaskStatusError(error));
  }
}

function* watchAddNewTaskStatus() {
  yield takeLatest(ADD_NEW_TASK_STATUS, addNewTaskStatus);
}

// Update Task Status
function* updateTaskStatus({ payload }) {
  try {
    const response = yield call(postUpdateTaskStatusApiCall, payload);
    yield put(updateTaskStatusSuccess(response));
  } catch (error) {
    yield put(updateTaskStatusError(error));
  }
}

function* watchUpdateTaskStatus() {
  yield takeLatest(UPDATE_TASK_STATUS, updateTaskStatus);
}

// Delete Task Status
function* deleteTaskStatus({ payload }) {
  try {
    const response = yield call(postDeleteTaskStatusApiCall, payload);
    yield put(deleteTaskStatusSuccess(response));
  } catch (error) {
    yield put(deleteTaskStatusError(error));
  }
}

function* watchDeleteTaskStatus() {
  yield takeLatest(DELETE_TASK_STATUS, deleteTaskStatus);
}

// Add New Task Type
function* addNewTaskType({ payload }) {
  try {
    const response = yield call(postAddNewTaskTypeApiCall, payload);
    yield put(addNewTaskTypeSuccess(response));
  } catch (error) {
    yield put(addNewTaskTypeError(error));
  }
}

function* watchAddNewTaskType() {
  yield takeLatest(ADD_NEW_TASK_TYPE, addNewTaskType);
}

// Update Task Type
function* updateTaskType({ payload }) {
  try {
    const response = yield call(postUpdateTaskTypeApiCall, payload);
    yield put(updateTaskTypeSuccess(response));
  } catch (error) {
    yield put(updateTaskTypeError(error));
  }
}

function* watchUpdateTaskType() {
  yield takeLatest(UPDATE_TASK_TYPE, updateTaskType);
}

// Delete Task Type

function* deleteTaskType({ payload }) {
  try {
    const response = yield call(postDeleteTaskTypeApiCall, payload);
    yield put(deleteTaskTypeSuccess(response));
  } catch (error) {
    yield put(deleteTaskTypeError(error));
  }
}

function* watchDeleteTaskType() {
  yield takeLatest(DELETE_TASK_TYPE, deleteTaskType);
}

// Add New Task Priority
function* addNewTaskPriority({ payload }) {
  try {
    const response = yield call(postAddNewTaskPriorityApiCall, payload);
    yield put(addNewTaskPrioritySuccess(response));
  } catch (error) {
    yield put(addNewTaskPriorityError(error));
  }
}

function* watchAddNewTaskPriority() {
  yield takeLatest(ADD_NEW_TASK_PRIORITY, addNewTaskPriority);
}

// Update Task Priority
function* updateTaskPriority({ payload }) {
  try {
    const response = yield call(postUpdateTaskPriorityApiCall, payload);
    yield put(updateTaskPrioritySuccess(response));
  } catch (error) {
    yield put(updateTaskPriorityError(error));
  }
}

function* watchUpdateTaskPriority() {
  yield takeLatest(UPDATE_TASK_PRIORITY, updateTaskPriority);
}

// Delete Task Priority
function* deleteTaskPriority({ payload }) {
  try {
    const response = yield call(postDeleteTaskPriorityApiCall, payload);
    yield put(deleteTaskPrioritySuccess(response));
  } catch (error) {
    yield put(deleteTaskPriorityError(error));
  }
}

function* watchDeleteTaskPriority() {
  yield takeLatest(DELETE_TASK_PRIORITY, deleteTaskPriority);
}

// Get Task Recent Activity List
function* getTaskRecentActivityList({ payload }) {
  try {
    const response = yield call(getTaskRecentActivityListApiCall, payload);
    yield put(getTaskRecentActivityListSuccess(response));
  } catch (error) {
    yield put(getTaskRecentActivityListError(error));
  }
}

function* watchGetTaskRecentActivityList() {
  yield takeLatest(GET_TASK_RECENT_ACTIVITY_LIST, getTaskRecentActivityList);
}

// Get Task Change Log List (field-level change history)
function* getTaskChangeLogList({ payload }) {
  try {
    const response = yield call(getTaskChangeLogListApiCall, payload);
    yield put(getTaskChangeLogListSuccess(response));
  } catch (error) {
    yield put(getTaskChangeLogListError(error));
  }
}

function* watchGetTaskChangeLogList() {
  yield takeLatest(GET_TASK_CHANGE_LOG_LIST, getTaskChangeLogList);
}

//Templates
// Get Task Template List
function* getTaskTemplateList() {
  try {
    const response = yield call(getTaskTemplateListApiCall);
    yield put(getTaskTemplateListSuccess(response));
  } catch (error) {
    yield put(getTaskTemplateListError(error));
  }
}

function* watchGetTaskTemplateList() {
  yield takeLatest(GET_TASK_TEMPLATE_LIST, getTaskTemplateList);
}
// Get Task Template Data
function* getTaskTemplateData({ payload }) {
  try {
    const response = yield call(getTaskTemplateDataApiCall, payload);
    yield put(getTaskTemplateDataSuccess(response));
  } catch (error) {
    yield put(getTaskTemplateDataError(error));
  }
}

function* watchGetTaskTemplateData() {
  yield takeLatest(GET_TASK_TEMPLATE_DATA, getTaskTemplateData);
}
// Create Task Template
function* createTaskTemplate({ payload }) {
  try {
    const response = yield call(postCreateTaskTemplateApiCall, payload);
    yield put(createTaskTemplateSuccess(response));
  } catch (error) {
    yield put(createTaskTemplateError(error));
  }
}

function* watchCreateTaskTemplate() {
  yield takeLatest(CREATE_TASK_TEMPLATE, createTaskTemplate);
}
// Update Task Template
function* updateTaskTemplate({ payload }) {
  try {
    const response = yield call(postUpdateTaskTemplateApiCall, payload);
    yield put(updateTaskTemplateSuccess(response));
  } catch (error) {
    yield put(updateTaskTemplateError(error));
  }
}

function* watchUpdateTaskTemplate() {
  yield takeLatest(UPDATE_TASK_TEMPLATE, updateTaskTemplate);
}
// Delete Task Template
function* deleteTaskTemplate({ payload }) {
  try {
    const response = yield call(postDeleteTaskTemplateApiCall, payload);
    yield put(deleteTaskTemplateSuccess(response));
  } catch (error) {
    yield put(deleteTaskTemplateError(error));
  }
}

function* watchDeleteTaskTemplate() {
  yield takeLatest(DELETE_TASK_TEMPLATE, deleteTaskTemplate);
}
// Search Task Template List APi Data
function* searchTaskTemplateList({ payload }) {
  try {
    const response = yield call(postSearchTaskTemplateListApiCall, payload);
    yield put(searchTaskTemplateListSuccess(response));
  } catch (error) {
    yield put(searchTaskTemplateListError(error));
  }
}

function* watchSearchTaskTemplateList() {
  yield takeLatest(SEARCH_TASK_TEMPLATE_LIST, searchTaskTemplateList);
}

//attachments
// Get Task Attachment List
function* getTaskAttachmentList() {
  try {
    const response = yield call(getTaskAttachmentListApiCall);
    yield put(getTaskAttachmentListSuccess(response));
  } catch (error) {
    yield put(getTaskAttachmentListError(error));
  }
}

function* watchGetTaskAttachmentList() {
  yield takeLatest(GET_TASK_ATTACHMENT_LIST, getTaskAttachmentList);
}
// Search Task Attachment List APi Data
function* searchTaskAttachmentList({ payload }) {
  try {
    const response = yield call(postSearchTaskAttachmentListApiCall, payload);
    yield put(searchTaskAttachmentListSuccess(response));
  } catch (error) {
    yield put(searchTaskAttachmentListError(error));
  }
}
function* watchSearchTaskAttachmentList() {
  yield takeLatest(SEARCH_TASK_ATTACHMENT_LIST, searchTaskAttachmentList);
}
// Get Task Attachment Data
function* getTaskAttachmentData({ payload }) {
  try {
    const response = yield call(getTaskAttachmentDataApiCall, payload);
    yield put(getTaskAttachmentDataSuccess(response));
  } catch (error) {
    yield put(getTaskAttachmentDataError(error));
  }
}

function* watchGetTaskAttachmentData() {
  yield takeLatest(GET_TASK_ATTACHMENT_DATA, getTaskAttachmentData);
}
// Delete Task Attachment
function* deleteTaskAttachment({ payload }) {
  try {
    const response = yield call(postDeleteTaskAttachmentApiCall, payload);
    yield put(deleteTaskAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteTaskAttachmentError(error));
  }
}

function* watchDeleteTaskAttachment() {
  yield takeLatest(DELETE_TASK_ATTACHMENT, deleteTaskAttachment);
}

// root saga

function* tasksCrmITSaga() {
  yield all([
    watchGetTasksCrmITList(),
    watchCreateTaskCrmIT(),
    watchGetTaskCrmIT(),
    watchUpdateTaskCrmIT(),
    watchClaimTaskCrmIT(),
    watchDeleteTaskCrmIT(),
    watchGetTaskStatusListCrmIT(),
    watchSearchTaskList(),
    watchGetTaskTypeList(),
    watchGetTaskPriorityList(),
    watchGetSingleTaskNoteData(),
    watchCreateSingleTaskNoteData(),
    watchSearchSingleJobTaskListForTimer(),
    watchSearchTaskTimeEntryList(),
    watchCreateTaskTimeEntry(),
    watchAddNewTaskStatus(),
    watchUpdateTaskStatus(),
    watchDeleteTaskStatus(),
    watchAddNewTaskType(),
    watchUpdateTaskType(),
    watchDeleteTaskType(),
    watchAddNewTaskPriority(),
    watchUpdateTaskPriority(),
    watchDeleteTaskPriority(),
    watchGetTaskRecentActivityList(),
    watchGetTaskChangeLogList(),
    watchGetTaskTemplateList(),
    watchGetTaskTemplateData(),
    watchCreateTaskTemplate(),
    watchUpdateTaskTemplate(),
    watchDeleteTaskTemplate(),
    watchSearchTaskTemplateList(),
    watchGetTaskAttachmentList(),
    watchSearchTaskAttachmentList(),
    watchGetTaskAttachmentData(),
    watchDeleteTaskAttachment(),
  ]);
}
export default tasksCrmITSaga;
